// Auto-generated by scripts/generate-registry.mjs from packages/modules/type_d_closed_loop_cup/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const type_d_closed_loop_cup: ModuleSchema = {
  "id": "type_d_closed_loop_cup",
  "uniqueId": "B3D_L40OQ",
  "createdAt": "2026-10-28T07:30:27.950Z",
  "updatedAt": "2026-10-28T07:30:27.950Z",
  "label": "Loop Cup",
  "description": "Type D wall with continuous closed-loop wavy surface strands.",
  "category": "rattan",
  "tags": [
    "type-d-closed-loop-cup"
  ],
  "sliders": [
    {
      "key": "diameter",
      "label": "Diameter",
      "min": 48,
      "max": 140,
      "default": 72,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Height",
      "min": 24,
      "max": 120,
      "default": 54,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "strandThickness",
      "label": "Strand Thickness",
      "min": 0.4,
      "max": 3,
      "default": 1,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "strandHeight",
      "label": "Strand Height",
      "min": 0.8,
      "max": 6,
      "default": 2,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "pathPitchZ",
      "label": "Path Pitch Z",
      "min": 3,
      "max": 10,
      "default": 5,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "waveAmplitude",
      "label": "Wave Amplitude",
      "min": 0,
      "max": 2,
      "default": 0.8,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "bundleCount",
      "label": "Bundle Count",
      "min": 1,
      "max": 3,
      "default": 1,
      "step": 1,
      "unit": ""
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "union_body",
      "label": "Wall and Loop Union",
      "default": "#7c3aed",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "loop_cup",
      "label": "Type D Loop Cup",
      "name": "Type D Loop Cup",
      "color": "#7c3aed",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "union_body",
          "label": "Wall and Loop Union",
          "name": "Wall and Loop Union",
          "groupId": 0,
          "colorKey": "union_body",
          "defaultColor": "#7c3aed",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Type D Loop Cup"
    }
  ]
};
